import { fetchData } from 'Utils/fetch-data';
import type { PostUserCourseResponse } from 'types';

class UserCourseApi {
  private endpoint: string;

  constructor(endpoint: string) {
    this.endpoint = endpoint;
  }

  /**
   * Asigna un curso a un empleado.
   * @param userId
   * @param coursesId
   * @returns
   */
  async post(userId: string, coursesId: string[]) {
    const response = await fetchData<PostUserCourseResponse>(this.endpoint, {
      method: 'POST',
      data: {
        userId,
        coursesId,
      },
    });
    return response;
  }

  /**
   * Remueve un curso asignado manualmente a un empleado.
   * @param userId
   * @param courseId
   * @returns
   */
  async remove(userId: string, courseId: string) {
    const response = await fetchData<{ success: boolean; message: string }>(this.endpoint, {
      method: 'DELETE',
      data: {
        userId,
        courseId,
      },
    });
    return response;
  }
}

export const userCourseApi = new UserCourseApi('/user-course');
